import React, { useEffect, useState } from 'react';

//PACKS
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

//Forms
import ProdutosForm from '../../../../containers/forms/produtos/Produtos';

//Components
import Body from '../../../../components/layoutcredenciamento/Body';
import Header from '../../../../components/layoutcredenciamento/Header';
import Footer from '../../../../components/layoutcredenciamento/Footer';
import Layout from '../../../../components/layoutcredenciamento/Layout';

//Utils
import { getEvento, setCategoriaUsuario, getCategoriaCred, getLinguagemCred } from '../../../../utils/eventosessioncred';

const Produtos  = () => {

    const [dados_base, setDadosBase] = useState({});
    const [categoria, getCategoria] = useState(getCategoriaCred());
    const [linguagem, getLinguagem] = useState(getLinguagemCred()!==undefined?getLinguagemCred():'pt');
    const dados_evento = getEvento();

    useEffect(() => {        
        if(dados_evento&&dados_evento.idevento){
            const categoria_usuario = 1;//Categoria Usuário Credenciamento
            setCategoriaUsuario(categoria_usuario);
            setDadosBase({
                idevento: dados_evento.idevento,
                idpromotora: dados_evento.idpromotora,
                idcategoria: categoria_usuario,
                validacadastro: dados_evento.validacadastro
            });
        }
    },[]);
    
    if(!dados_base.idevento){
        return null;
    }
    
    return (
        <Layout>
            <Header getLinguagem={getLinguagem} getCategoria={getCategoria} prelogin={false}  pagina="produtos"/>
            <Body>
                <ProdutosForm {...dados_base} lingua={linguagem} categoriacred={categoria} />
            </Body>
            <Footer />
        </Layout>
    );
}

const mapStateToProps = (state) => {
    return {        
        pendingTasks: state.pendingTasks,
        trads: state.reducerTraducoes,
    }
}

export default connect(mapStateToProps)(withRouter(Produtos));